import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID;
const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin;

if (!clientId || clientId.startsWith('00000000')) {
  // eslint-disable-next-line no-console
  console.warn(
    '[msalConfig] VITE_AZURE_CLIENT_ID is not set. Login will fail until you configure .env.local.',
  );
}

export const msalConfig = {
  auth: {
    clientId: clientId || '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${tenantId || 'common'}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[msal]', message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes requested on every sign-in.
 *
 * Deliberately excludes `Mail.Send` — it's requested on demand via
 * `mailRequest` only when the user actually submits a request that triggers
 * an email. Keeping it out of the login scopes avoids forcing everyone
 * through a re-consent popup, which Safari tends to block when it isn't
 * tied to a direct click.
 */
export const loginRequest = {
  scopes: ['User.Read', 'Sites.ReadWrite.All'],
};

/** Scopes required to call Graph /sites endpoints. */
export const graphRequest = {
  scopes: ['Sites.ReadWrite.All'],
};

/**
 * Scopes required to send a message as the signed-in user. Requested only
 * when we actually need to send mail (e.g. after a team member submits a
 * request from My Account) so most sessions never touch this scope.
 *
 * The Proxemics Portal app registration must have the `Mail.Send` Microsoft
 * Graph delegated permission granted (with admin consent) — otherwise
 * acquireTokenSilent will fall back to a popup prompting for consent.
 */
export const mailRequest = {
  scopes: ['Mail.Send'],
};

export const pca = new PublicClientApplication(msalConfig);
